// API Constants
export const MAX_POLL_COUNT = 80;
export const POLL_INTERVAL = 500;
export const PROGRESS_LOADING_DURATION = 15000;

// UI Constants
export const MAP_INITIAL_ZOOM = 7;
export const MAP_MAX_ZOOM = 18;
export const MAP_MIN_ZOOM = 2;
export const INFO_WINDOW_Z_INDEX = 30;

// Layout Constants
export const STICKY_TOP_OFFSET = 75;
export const MAP_STICKY_TOP_OFFSET = 130;
export const MAP_WIDTH = 400;
export const CONTENT_MAX_WIDTH = 650;
export const CONTENT_XL_MAX_WIDTH = 1200;

// Animation Constants
export const SURVEY_CONFIRMATION_TIMEOUT = 2000;
export const SCROLL_BEHAVIOR_DELAY = 250;
export const HOTEL_SCROLL_OFFSET = 160;

// Text Constants
export const DEFAULT_PLACEHOLDER = "What will your next destination be...";
export const SURVEY_PLACEHOLDER = "Share your thoughts...";
export const ERROR_MESSAGE = "Something went wrong, please try again later";
export const WELCOME_MESSAGE_PREFIX = "Hi";
export const WELCOME_MESSAGE_SUFFIX = ", where do you want to go?";
export const WELCOME_DESCRIPTION =
  "We search multiple dates and locations at once, summarizing the best options for you.";
export const NO_RESULTS_MESSAGE =
  "We couldn't find anything that fits your criteria";
export const NO_RESULTS_SUGGESTION_SUFFIX = " you can try these prompts";
export const FOLLOWUP_SUGGESTIONS_HEADER =
  "Try these prompts to get more results";
export const THINKING_TEXT = "Thinking...";
export const NEW_SESSION_TEXT = "New Chat";
export const SHARE_FEEDBACK_TEXT = "Share Feedback";
export const FEEDBACK_THANK_YOU = "Thank you for your feedback!";
export const FEEDBACK_RECORDED = "Your response has been recorded.";
export const CANCEL_TEXT = "Cancel";
export const SUBMIT_TEXT = "Submit";
export const TRY_THESE_PROMPTS_TEXT = "Try These Prompts";
export const NO_SUGGESTIONS_TEXT = "No suggestions available";

// URLs
export const NEW_SESSION_URL = "/hotel/search/researcher";
export const INITIAL_PROMPTS_API = "/api/search/hotel_research/initial_prompts";
export const SESSIONS_API = "/api/search/hotel_research/sessions";
export const SESSION_API = "/api/search/hotel_research";
export const RESEARCH_API = "/api/search/hotel_research";
export const FOLLOWUP_API = "/api/search/hotel_research/followup";

// Concierge Tool Loading Messages
export const TOOL_LOADING_MESSAGES: Record<string, string> = {
  search_hotels: "Searching for hotels...",
  create_rate_alert: "Setting up price alert...",
  get_loyalty_info: "Checking your loyalty accounts...",
  get_booking_link: "Preparing your booking link...",
};

// Survey Constants
export const FEEDBACK_SURVEY_NAME = "researcher_feedback";
export const SURVEY_SHOWN_EVENT = "survey shown";
export const SURVEY_SENT_EVENT = "survey sent";
